import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import SmoothCollapse from 'react-smooth-collapse'

interface Props {
	key: number
	id: string
	content: any
	backgroundColor: string
	leftBorderColour: any
	onClick: any
	children: any
	expanded?: boolean
	chevron?: boolean
	className?: string
}

export function ExpandableComponent({
	key,
	id,
	children,
	onClick,
	leftBorderColour,
	content,
	backgroundColor,
	expanded = false,
	chevron = true,
	className = '',
}: Props) {
	const [expand, setExpand] = useState(expanded)
	useEffect(() => {
		setExpand(expanded)
	}, [expanded])

	return (
		<div key={key} id={id} className={className}>
			<div
				style={{
					backgroundColor: backgroundColor,
					border: '.5px solid #e9e8da',
					borderLeft: `3px solid ${leftBorderColour}`,
				}}
				className={`container-expand pointer ${expand ? 'expanded' : 'collapsed'}`}
				onClick={() => onClick(setExpand(!expand))}>
				<div className="d-flex align-items-center justify-content-between h-100">
					{content}
					{chevron && (
						<FontAwesomeIcon
							icon={!expand ? 'chevron-down' : 'chevron-up'}
							className="d-flex mr-4"
						/>
					)}
				</div>
			</div>
			<SmoothCollapse
				expanded={expand}
				children={children}
				allowOverflowWhenOpen={true}
			/>
		</div>
	)
}